// Only passive pages can reload automatically. Forms and active matches keep their state.
export function startSiteUpdates() {
  const current = Array.from(document.scripts).map(script => script.src).find(src => /\/static\/js\/main\.[^/]+\.js$/.test(src));
  if (!current) return;
  let busy = false;
  let dirty = false;
  let latest;
  let lastInteraction = Date.now();
  document.addEventListener('input', () => { dirty = true; }, true);
  ['pointerdown', 'keydown'].forEach(event => document.addEventListener(event, () => { lastInteraction = Date.now(); }, true));
  const safeToReload = () => !dirty && !window.__PB_LIVE_BATTLE__
    && /^(\/|\/history\/?|\/battle\/\d+\/?|\/battle-result\/\d+\/?)$/.test(window.location.pathname)
    && !document.querySelector('[role="dialog"]')
    && !['INPUT', 'TEXTAREA', 'SELECT'].includes(document.activeElement?.tagName)
    && Date.now() - lastInteraction > 10000;
  const check = async () => {
    if (busy || document.visibilityState !== 'visible') return;
    busy = true;
    try {
      const response = await fetch('/asset-manifest.json', { cache: 'no-store' });
      if (!response.ok) return;
      const manifest = await response.json();
      latest = manifest.files?.['main.js'];
      if (!latest || new URL(latest, window.location.origin).pathname === new URL(current).pathname) return;
      if (safeToReload()) { window.location.reload(); return; }
      if (!document.getElementById('site-update-notice')) {
        const button = document.createElement('button');
        button.id = 'site-update-notice';
        button.textContent = '网站有更新，完成当前操作后点击刷新';
        button.style.cssText = 'position:fixed;bottom:20px;left:50%;transform:translateX(-50%);z-index:99999;padding:12px 20px;border:0;border-radius:24px;background:#ff4d4f;color:white;cursor:pointer;max-width:90vw;';
        button.onclick = () => window.location.reload();
        document.body.appendChild(button);
      }
    } catch (_) { /* Connection failures must not disrupt a match. */ }
    finally { busy = false; }
  };
  setInterval(check, 60000);
  window.addEventListener('focus', check);
  document.addEventListener('visibilitychange', check);
  setTimeout(check, 15000);
}
